// Hero Sticky CTA Button for Mobile
document.addEventListener('DOMContentLoaded', function() {
  // Only run on mobile
  if (window.innerWidth > 767) return;
  
  const heroSection = document.querySelector('[data-section-type="image-with-text-overlay"], .banner');
  if (!heroSection) return;
  
  const originalButton = heroSection.querySelector('.button');
  if (!originalButton) return;
  
  // Create sticky button container
  const stickyContainer = document.createElement('div');
  stickyContainer.className = 'hero-sticky-cta';
  
  // Clone the original button
  const stickyButton = originalButton.cloneNode(true);
  stickyContainer.appendChild(stickyButton);
  
  // Add to body
  document.body.appendChild(stickyContainer);
  
  // Add class to body for CSS targeting
  document.body.classList.add('has-sticky-cta');
  
  // Intersection Observer to show/hide sticky button
  const observerOptions = {
    root: null,
    rootMargin: '-50% 0px',
    threshold: 0
  };
  
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Hero is visible, hide sticky button
        stickyContainer.classList.remove('is-visible');
      } else {
        // Hero is not visible, show sticky button
        stickyContainer.classList.add('is-visible');
      }
    });
  }, observerOptions);
  
  // Observe the hero section
  observer.observe(heroSection);
  
  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth > 767) {
        stickyContainer.classList.remove('is-visible');
        document.body.classList.remove('has-sticky-cta');
      } else {
        document.body.classList.add('has-sticky-cta');
      }
    }, 250);
  });
});